"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M7.2 9.62222V18.8667H4V9.62222H7.2ZM13.3511 9.62222V11.0793H13.3938C13.8043 10.3699 14.8088 9.62222 16.3062 9.62222C19.424 9.62222 20 11.4899 20 13.9194V18.8667H16.9215V14.4797C16.9215 13.4337 16.9019 12.088 15.322 12.088C13.7196 12.088 13.4751 13.2279 13.4751 14.4051V18.8667H10.4V9.62222H13.3511ZM5.60103 5C6.48372 5 7.2 5.69014 7.2 6.54049C7.2 7.39134 6.48372 8.08148 5.60103 8.08148C4.71473 8.08148 4 7.39134 4 6.54049C4 5.69014 4.71473 5 5.60103 5Z"
  })];
};

exports.default = _default;